import React from 'react';

import './Footer.css';
import { theme } from '../../theme/designSystem';
import { headerData } from '../../data/headerData';

const START_YEAR = 2023;

function Footer() {
    const currentYear = new Date().getFullYear();
    const years = currentYear > START_YEAR ? `${START_YEAR}-${currentYear}` : `${START_YEAR}`;

    return (
        <footer className="footer" style={{ backgroundColor: theme.tertiary, borderColor: theme.border }}>
            <div className="footer--container">
                <p className="footer--copy" style={{ color: theme.textSecondary }}>
                    © {years} {headerData.name}
                </p>
                <p className="footer--role" style={{ color: theme.textTertiary }}>
                    {headerData.role} · {headerData.location}
                </p>
            </div>
        </footer>
    );
}

export default Footer;
